<div class="map-inner">
    <p-chart type="line" [data]="revenueData" [options]="chartOptionsForGraph"></p-chart>
</div>